"use client";

import { Box, Flex, Skeleton } from "@chakra-ui/react";
import { useThemeTokens } from "@/lib/theme/tokens";

export const TeacherPublicPageSkeleton = () => {
  const theme = useThemeTokens();

  return (
    <Flex direction="column" maxW="720px" mx="auto" w="100%">
      <Skeleton height="20px" width="180px" mb={6} borderRadius="4px" />

      <Flex justify="center" mb={6}>
        <Skeleton w={{ base: "160px", md: "200px" }} aspectRatio="3 / 4" borderRadius="12px" />
      </Flex>

      <Box pb={6} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
        <Skeleton height="12px" width="88px" mb={3} borderRadius="4px" />
        <Skeleton height={{ base: "34px", md: "42px" }} width="75%" mb={3} borderRadius="6px" />
        <Skeleton height="16px" width="55%" mb={4} borderRadius="4px" />
        <Skeleton height="36px" width="88px" borderRadius="8px" />
      </Box>

      <Box py={6} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
        <Flex direction="column" gap={2}>
          <Skeleton height="16px" width="100%" borderRadius="4px" />
          <Skeleton height="16px" width="100%" borderRadius="4px" />
          <Skeleton height="16px" width="92%" borderRadius="4px" />
        </Flex>
      </Box>

      <Box py={6} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
        <Skeleton height="12px" width="100px" mb={4} borderRadius="4px" />
        <Box borderTopWidth="1px" borderColor={theme.borderGlass.subtle}>
          {[1, 2].map((i) => (
            <Flex
              key={i}
              gap={8}
              py={6}
              borderBottomWidth={i === 2 ? 0 : "1px"}
              borderColor={theme.borderGlass.subtle}
            >
              <Skeleton height="12px" width="72px" borderRadius="4px" />
              <Skeleton height="20px" width="50%" borderRadius="4px" flex={1} />
              <Skeleton height="32px" width="120px" borderRadius="8px" />
            </Flex>
          ))}
        </Box>
      </Box>

      <Box pt={3}>
        <Skeleton height="12px" width="88px" mb={4} borderRadius="4px" />
        <Box borderTopWidth="1px" borderColor={theme.borderGlass.subtle}>
          <Flex justify="space-between" align="center" py={4} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
            <Box flex={1}>
              <Skeleton height="12px" width="56px" mb={2} borderRadius="4px" />
              <Skeleton height="16px" width="140px" borderRadius="4px" />
            </Box>
            <Skeleton boxSize="16px" borderRadius="4px" />
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};
